
import { useMemo } from "react";
import { MapLocation } from "@/types/location";

export const useLocationFiltering = (
  locations: MapLocation[],
  activeRegion: string,
  activeMediaKind: string,
  activeScreenType: string,
  activeMediaOwner: string
) => {
  const filteredLocations = useMemo(() => {
    if (locations.length === 0) return [];
    return locations.filter(location => {
      const mediaOwnerMatch = activeMediaOwner === 'all' || location.mediaOwner === activeMediaOwner;
      const regionMatch = activeRegion === 'all' || location.region === activeRegion;
      const mediaKindMatch = activeMediaKind === 'all' ||
        location.mediaKind?.toLowerCase() === activeMediaKind.toLowerCase();
      const screenTypeMatch = activeScreenType === 'all' || location.screenType === activeScreenType;
      return mediaOwnerMatch && regionMatch && mediaKindMatch && screenTypeMatch;
    });
  }, [locations, activeRegion, activeMediaKind, activeScreenType, activeMediaOwner]);

  return { filteredLocations };
};

